import { RoleSwitchedView } from "Infrastructure/Components/RoleBasedView/RoleSwitchedView";
import { QuestTable } from "Infrastructure/Components/Tables/QuestTable";
import { UserQuestView } from "Infrastructure/Quests/Components/UserQuestView";
import { Box } from "@mui/material";

export const QuestsPage = () => {
  return (
    <RoleSwitchedView
      gameMasterView={
        <Box sx={{ p: 4, height: "calc(100vh - 120px)", overflow: "hidden" }}>
          <QuestTable />
        </Box>
      }
      userView={<UserQuestView />}
    />
  );
};
